import module from 'nominas/sumario/module.js'

const schema = {
  id_tipo_comision: 'number',
  cobro_impuesto_estatal: 'boolean',
  comision_porcentaje: 'number',
  comision_porcentaje_sa: 'number',
  comision_porcentaje_op: 'number',
  iva_porcentaje: 'number',
  impuestos: {
    porcentaje: 'number',
    tipoId: 'number',
  }
}

export class NominasCatalogoEsquemaService {
  constructor ($http) {
    this.$http = $http
  }

  get (proyectoId) {
    return this.$http.get('/api/nominas/catalogos/esquemas', {
      params: {id_proyecto: proyectoId},
      schema: schema,
    })
  }
}

module.service('NominasCatalogoEsquema', NominasCatalogoEsquemaService)



// WEBPACK FOOTER //
// ./src/nominas/sumario/services/Catalogo/Esquema.js